
import { defineComponent } from "vue";
import UtilsService from "@/services/UtilsService";
const utilsService = new UtilsService();
import router from "@/router";

export default defineComponent({
  name: "PlaceRow",
  props: {
    place: Object,
    usersNumber: Number,
  },
  setup(props) {
    console.log("setup with props", props.place);
  },
  methods: {
    /**
     * Go to details of a place
     */
    goToPlaceDetails: async (placeId: string) => {
      console.log("go to details of a place FROM component", placeId);
      router.push(`/place/${placeId}`);
    },

    // return next payment date
    getNextPaymentDate(lastPaymentDate: number) {
      return utilsService.getNextPaymentDate(lastPaymentDate, false, true);
    },
  },
});
